import React, { useState } from 'react';
import {SimulatorOfferModel,DiscountModel,YesNo,DiscountType} from '../models/superbit-api-models'
import { StatOptions } from 'fs';
import moment from 'moment';
type Props = {
    discount:any;
    onChanged:any;
  };
  
  
  type State = {
    discount:any;
    onChanged:any;
    sum:number,  
    minSum:number,
    forceActive:boolean,
    feeParticipation:number,
    SelectData:any 
    };

export class ShlomoDiscount extends React.Component<Props,State>
{
    constructor(props:any) {
        super(props); 
        this.state = {
            discount:this.props.discount,
            onChanged:null,
            sum:this.props.discount.sum,
            minSum:this.props.discount.minSum,
            forceActive:this.props.discount.forceActive,
            feeParticipation:this.props.discount.feeParticipation!=null?parseInt(this.props.discount.feeParticipation):0,
            SelectData:this.props.discount.selectValue!=null && this.props.discount.selectValue.length>0? JSON.parse(this.getCorrectData(this.props.discount.selectValue)):null
        }


        

        
      }

      getCorrectData = (jsonData:string)=>{
        return jsonData.replace(/label=/g, '"label":').replace(/value=/g, '"value":').replace(/(\d+)%/g, '$1%').replace(/%/g, '%').replace(/=/g, ':');
      }

      setCheckboxStateData = (name:string,event:any) => {
        
        const data = this.state.discount;
        data[name] = event.currentTarget.checked;
        this.setState({discount: data});

      }

      setStateInputData = (name:string,event:any) => {
        console.log('setStateInputData', name, event);

        let input = parseInt(event.target.value);
        
        // Check if newValue exceeds max
        if (input > event.target.max) {
          input = parseInt(event.target.max);
        }
        
        // Check if newValue is less than min
        if (input < event.target.min) {
          input = parseInt(event.target.min);
        }


        const data = this.state.discount;
        data[name] = input;
        this.setState({discount: data});
        this.props.onChanged(data);
      }

      onSelectChange2 = (value: string) => {
        
      }

      setAutoActive = async (name:string,event:any) => {
        const data = this.state.discount;

        if(event.currentTarget.checked)
            data.autoActive=YesNo._0;
        else
            data.autoActive=YesNo._1;
       await this.setState({discount: data}, ()=>{
          this.props.onChanged(data);
        });
        console.log('setAutoActive', name);
      }
      
      
    render() {

       return (        
        <>{this.state.discount!=null?
            <>
            <div className="form-table-row flex-space-between flex-centered">
       <div className="form-table-column">
           <div className="input-row">
     
           <input  type="checkbox" disabled={this.state.forceActive} onChange={(e:any) =>  this.setAutoActive("autoActive", e)} checked={this.state.discount.autoActive==YesNo._0} />
                     <label>{this.state.discount.name}</label>         
           </div>
       </div>
       <div className="form-table-column">
           <div className="input-row">
               <div className="input-wrapper flex-space-between flex-centered">
                   <div className=" small-icon  pointer">
                    {this.props.discount.discountType== DiscountType._select && this.state.SelectData!=null?
                    <select value={this.state.discount.sum} onChange={(e:any) =>  this.setStateInputData("sum", e)}>
                    {this.state.SelectData.map((item:any, index:number) => (
                      <option key={index} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>                    
                    :
<input type="number" min={this.state.minSum==null?0:this.state.minSum} max={this.state.sum} className={this.state.discount.autoActive==YesNo._0?"":"disabled"} onChange={(e:any) =>  this.setStateInputData("sum", e)} value={this.state.discount.sum} />    
                    }
                   
                     </div>%
               </div>
           </div>
       </div>
       <div className="form-table-column">
        {this.state.discount.feeParticipation!=null && this.state.discount.feeParticipation>0?
<div className="input-row">
<div className="input-wrapper flex-space-between flex-centered">
    <div className=" small-icon  pointer">
    <input type="number" min={this.state.minSum==null?0:this.state.minSum} max={this.state.feeParticipation} className={this.state.discount.autoActive==YesNo._0?"hh":"disabled"} onChange={(e:any) =>  this.setStateInputData("feeParticipation", e)} value={this.state.discount.feeParticipation} />
      </div>%
</div>
</div>

        :""}
           
       </div>
     </div>
             </>
            :""}</>
       );

        
      }
  }
